/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable arrow-body-style */
import {
 Autocomplete,
 CircularProgress,
 SxProps,
 TextField,
 Theme,
 useTheme,
} from '@mui/material';
import { debounce } from '@mui/material/utils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import {
 Control,
 Controller,
 Path,
 UseFormSetValue,
 useWatch,
} from 'react-hook-form';

import { get, post } from '../../api/api';
import { FormValues } from '../../types/types';
import { getModelInfo } from '@/utils/structureUtils';

const SelectApi = <T extends FormValues = FormValues>({
 name,
 url,
 filter,
 label,
 isEditable,
 operator,
 control,
 setValue,
 multiple = false,
 disabled = false,
 isGet = false,
 styles,
}: {
 name: Path<T>;
 url: string;
 filter: string;
 label: string;
 isEditable?: boolean;
 operator: 'contains' | 'eq';
 control: Control<T, any>;
 setValue: UseFormSetValue<T>;
 multiple?: boolean;
 disabled?: boolean;
 isGet?: boolean;
 styles?: SxProps<Theme> | ((theme: Theme) => SxProps<Theme>);
}) => {
 const theme = useTheme();
 const [options, setOptions] = useState([]);
 const [loading, setLoading] = useState(false);
 const [inputValue, setInputValue] = useState('');
 const selectedValue = useWatch({ control, name });
 const filterName = getModelInfo(filter).name;

 const getOptionName = (option: any) => {
  return (
   options.find((o) => (o as any)?.Id === (option?.Id || option))?.[
    filterName
   ] ||
   option?.[filterName] ||
   ''
  ).toString();
 };

 //  console.log(name, filter, url);

 const fetchOptions = useCallback(
  async (val?: string) => {
   setLoading(true);
   try {
    const apiParams = JSON.parse(filter);

    const filtersData = val
     ? [
        ...(val
         ? [
            {
             field: filterName,
             operator,
             value: val,
            },
           ]
         : []),
        ...(apiParams?.filters || []),
       ]
     : apiParams?.filters;
    if (Array.isArray(filtersData) && filtersData.length > 1) {
     filtersData[0].logic = 'And';
    }
    const response = await (isGet ? get : post)(url.replace('/api', ''), {
     ...apiParams,
     filters: filtersData,
    });
    setOptions(response.data || []);
   } catch (error) {
    console.error('Failed to load options:', error);
    setOptions([]);
   } finally {
    setLoading(false);
   }
  },
  [filter, filterName, isGet, operator, url],
 );

 const debouncedFetchOptions = useMemo(
  () => debounce((val: string) => fetchOptions(val), 500),
  [fetchOptions],
 );

 useEffect(() => {
  if (multiple) {
   return;
  }

  if (!selectedValue) {
   setInputValue('');
   return;
  }

  const nextValue = getOptionName(selectedValue);
  if (!nextValue) {
   return;
  }

  setInputValue((prev) => (prev ? prev : nextValue));
 }, [multiple, selectedValue, options]);

 useEffect(() => {
  return () => {
   debouncedFetchOptions.clear();
  };
 }, [debouncedFetchOptions]);

 return (
  control && (
   <Controller
    name={name}
    control={control}
    render={({ field }) => {
     //  console.log('selectApi field', field);
     return (
      <Autocomplete
       {...field}
       multiple={multiple}
       onOpen={() => {
        fetchOptions(inputValue);
       }}
       disabled={disabled || !isEditable}
       value={field.value || (multiple ? [] : null)}
       inputValue={inputValue}
       onChange={(_, value: any) => {
        // console.log('onChange', value, _);
        if (!multiple) {
         setInputValue(value ? getOptionName(value) : '');
        }
        setValue(
         name,
         value || (multiple ? [] : null),
         {
          shouldDirty: true,
          shouldTouch: true,
         }
        );
       }}
       options={options}
       renderOption={(props, option) => (
        <li {...props} key={`${filterName}-${option[filterName]}-${option.Id}`}>
         {option[filterName]}
        </li>
       )}
       getOptionLabel={(option: any) => getOptionName(option)}
       filterOptions={(x) => x} // Disable client-side filtering
       onInputChange={(_, val, reason) => {
        // console.log('onInputChange', reason, field.value, val);
        if (reason === 'reset') {
         return;
        }
        if (reason === 'clear') {
         setInputValue('');
         //  setValue('');
         //  clearValue();
         return;
        }

        if (field.value === val) return;
        setInputValue(val);
        debouncedFetchOptions(val);

        // if (field.value[filterName] === value) return;
        // setInputValue(value);
        // fetchOptions(value);
       }}
       isOptionEqualToValue={(option, value) => {
        return (option as any).Id === value.Id;
       }}
       loading={loading}
       renderInput={(params) => (
        <TextField
         {...params}
         label={label}
         variant="outlined"
         disabled={disabled || !isEditable}
         sx={
          typeof styles === 'function'
           ? styles(theme)
           : (styles as SxProps<Theme>) ||
             {
              //   backgroundColor: 'transparent',
             }
         }
         //  slotProps={{
         //   input: {
         //    ...params.inputProps,
         //    sx: {
         //     // backgroundColor: 'white',
         //    },
         //   },
         //  }}
         InputProps={{
          ...params.InputProps,
          endAdornment: (
           <>
            {loading ? (
             <CircularProgress
              color="inherit"
              size={20}
              sx={{ pointerEvents: 'none' }}
             />
            ) : null}
            {params.InputProps.endAdornment}
           </>
          ),
         }}
        />
       )}
       sx={{ width: '100%' }}
      />
     );
    }}
   />
  )
 );
};
export default SelectApi;
